var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('message-header', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_vm.saving ? _c('div', {
    staticClass: "absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
  }, [_c('span', {
    staticClass: "h-6 w-6 ml-4 mt-1/4 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white",
    on: {
      "click": _vm.saveSpecificRights
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-full mt-10 mb-10"
  }, [_c('h3', {
    staticClass: "w-full my-5 lg:my-15 2xl:my-20"
  }, [_vm._v("\n      Ajouter des droits d'accès "), _c('br'), _vm._v("spécifiques\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full text-left text-pink-600 text-lg mb-10 mx-5 lg:mx-15 2xl:mx-20"
  }, [_vm._v("\n      DROITS ET RESTRICTIONS\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 mx-5 lg:mx-15 2xl:mx-20"
  }, [_c('div', {
    staticClass: "col-span-full sm:col-span-1"
  }, [_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_read');
  }).length > 0 ? _c('div', [_c('checkbox-indigo', {
    staticClass: "text-indigo-600",
    attrs: {
      "name": "Lecture",
      "libelle": "LECTURE",
      "color-libelle": "indigo-600",
      "value": (((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {}).all,
      "size-libelle": "text-base"
    },
    on: {
      "input": function (newValue) {
        (((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {}).all = newValue;
        _vm.checkall('read', 'all', newValue);
        if (!newValue) {
          (((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {}).all = newValue;
          _vm.checkall('edit', 'all', newValue);
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_read');
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {}).all = newValue;
          _vm.checkall('read', mod.name, newValue);
          _vm.decheckall('read', mod.name, newValue);
          if (!newValue) {
            ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {}).all = newValue;
            _vm.checkall('edit', mod.name, newValue);
            _vm.decheckall('edit', mod.name, newValue);
          }
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return _vm.permissions.includes(p.name + '_read') && p.name != _vm.constants.PAGE_NEOPASS_FORM_DOCUMENTS;
    }), function (page, numPage) {
      return _c('div', {
        key: numPage
      }, [_c('checkbox-indigo', {
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "value": ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name],
          "color-libelle": "text-gray-600",
          "size-libelle": "text-base",
          "weight-libelle": "font-light"
        },
        on: {
          "input": function (newValue) {
            ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name] = newValue;
            _vm.decheckall('read', mod.name, newValue);
            if (!newValue) {
              ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name] = newValue;
              _vm.decheckall('edit', mod.name, newValue);
            }
          }
        }
      })], 1);
    }), _vm._v(" "), _vm.permissions.includes(mod.name + '_auto_eval_read') ? _c('checkbox-indigo', {
      staticClass: "text-gray-600",
      attrs: {
        "name": mod.name + '_auto_eval_read',
        "libelle": "Auto Evaluation Bénéficiaire",
        "color-libelle": "gray-600",
        "value": ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'],
        "size-libelle": "text-base",
        "weight-libelle": "font-light"
      },
      on: {
        "input": function (newValue) {
          ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'] = newValue;
          _vm.decheckall('read', mod.name, newValue);
          if (!newValue) {
            ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'] = newValue;
            _vm.decheckall('edit', mod.name, newValue);
          }
        }
      }
    }) : _vm._e()], 2);
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-span-full sm:col-span-1"
  }, [_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_edit');
  }).length > 0 ? _c('div', [_c('checkbox-indigo', {
    attrs: {
      "name": "Ecriture",
      "libelle": "ECRITURE",
      "value": (((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {}).all,
      "color-libelle": "text-indigo-600",
      "size-libelle": "text-base"
    },
    on: {
      "input": function (newValue) {
        (((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {}).all = newValue;
        _vm.checkall('edit', 'all', newValue);
        if (newValue) {
          (((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {}).all = newValue;
          _vm.checkall('read', 'all', newValue);
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listNeopassModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_edit');
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {}).all = newValue;
          _vm.checkall('edit', mod.name, newValue);
          _vm.decheckall('edit', mod.name, newValue);
          if (newValue) {
            ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {}).all = newValue;
            _vm.checkall('read', mod.name, newValue);
          }
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return _vm.permissions.includes(p.name + '_edit') && p.name != _vm.constants.PAGE_NEOPASS_FORM_DOCUMENTS;
    }), function (page, numPage) {
      return _c('div', {
        key: numPage
      }, [_c('checkbox-indigo', {
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "value": ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name],
          "color-libelle": "text-gray-600",
          "size-libelle": "text-base",
          "weight-libelle": "font-light"
        },
        on: {
          "input": function (newValue) {
            ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name] = newValue;
            _vm.decheckall('edit', mod.name, newValue);
            if (newValue) {
              ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name] = newValue;
            }
          }
        }
      })], 1);
    }), _vm._v(" "), _vm.permissions.includes(mod.name + '_auto_eval_edit') ? _c('checkbox-indigo', {
      staticClass: "text-gray-600",
      attrs: {
        "name": mod.name + '_auto_eval_edit',
        "libelle": "Auto Evaluation Bénéficiaire",
        "color-libelle": "gray-600",
        "value": ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'],
        "size-libelle": "text-base",
        "weight-libelle": "font-light"
      },
      on: {
        "input": function (newValue) {
          ((((_vm.specificRightsToEdit || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'] = newValue;
          _vm.decheckall('edit', mod.name, newValue);
          if (newValue) {
            ((((_vm.specificRightsToEdit || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'] = newValue;
          }
        }
      }
    }) : _vm._e()], 2);
  })], 2)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }